export const checkIsStaging = () =>
  window.location.href.includes("website.digitaldukaan.app") || window.location.href.includes("localhost");
